import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import { Tooltip } from '@mui/material';
import { GlobalContext } from '../../globalState';
import { useContext } from 'react';

/**
 * シフト変更がある場合のエクスクラメーションマーク
 * @param {*} fontSize フォントサイズ 
 * @returns 
 */
const ChangeShiftPriorityHighIcon = (props) =>{

    const {fontSize, margin} = props;

    
    const Env_msts = useContext(GlobalContext).Env_msts;
    const DISPLAY_STYLE_CHANGE_SHIFT_PRIORITY_HIGH_ICON = Env_msts.find(p=>p.env_key==="DISPLAY_STYLE_CHANGE_SHIFT_PRIORITY_HIGH_ICON")?.env_value;

    const title = "シフト変更あり";

    const style={
        icon:{  
            fontSize:fontSize||"1.2rem",
            height:"100%",
            color:"red", 
            margin:margin||"auto", 
            padding:"0px",
            display:DISPLAY_STYLE_CHANGE_SHIFT_PRIORITY_HIGH_ICON || "none"
        }
    }

    return(
        <Tooltip
            title={title}
        >
            <PriorityHighIcon style={style.icon}/>
        </Tooltip>
    );


}

export default ChangeShiftPriorityHighIcon;